export default "__VITE_ASSET__DoVhmAUc__"